/* eslint-disable import/no-cycle */
import { Stack, HStack } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormBuilderComponentProps } from '../types';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormTextInput from '../formInputs/FormTextInput';
import InputPreview from '../formInputs/InputPreview';

function AddressFieldComponent({ fieldId, labelRightRenderer, isAdvanced }: Omit<FormBuilderComponentProps, 'path'>) {
  const { t } = useTranslation('hrFormTemplate');

  return (
    <Stack>
      <HStack justify="space-between">
        <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
        {labelRightRenderer}
      </HStack>
      <FormTextInput
        fieldId={fieldId}
        placeholder={t('formBuilder.editorPlaceholder.address')}
        isAdvanced={isAdvanced || false}
      />
      <InputPreview value="Address" fieldId={fieldId} />
    </Stack>
  );
}

export const AddressField = React.memo(
  AddressFieldComponent,
  (prev, next) =>
    // eslint-disable-next-line
    prev.fieldId === next.fieldId && prev.isAdvanced === next.isAdvanced && prev.labelRightRenderer === next.labelRightRenderer,
);
